import React from 'react';
import translate from '../translate';

function Map() {
    return (
        <div className="map-section mb-none-120">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14624.633757136551!2d8.540674999999998!3d47.4178927!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x478c6b072d4d5db3%3A0xc3b6ee3216b4edb8!2sGlattalstr.%2076%2C%208052%20Z%C3%BCrich%2C%20Switzerland!5e0!3m2!1sen!2sus!4v1654321234567!5m2!1sen!2sus" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
    );
}

export default Map;